export default "__VITE_ASSET__0317b4c5__"